import {Box, Button, Typography} from '@mui/material';
import {FC, useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {PageHeaderProps} from './PageHeader.types';
import {actionButtonSx, iconBadgeSx, pageHeaderWrapperSx, titleSx, titleWrapperSx} from './PageHeader.sx';

export const PageHeader: FC<PageHeaderProps> = ({
                                                    title,
                                                    onClick,
                                                    buttonText,
                                                    onlyTitle,
                                                    children,
                                                    icon,
                                                    titleSuffix,
                                                }) => {
    const [pageTitle, setPageTitle] = useState<string>('');
    useEffect(() => {
        if (title !== 'undefined undefined' && title !== 'undefined') {
            // TODO: fix temporary condition
            setPageTitle(title);
        }
    }, [title]);
    return (
        <Box sx={pageHeaderWrapperSx}>
            <Box sx={titleWrapperSx}>
                {icon && <Box sx={iconBadgeSx}>{icon}</Box>}
                <Typography
                    sx={titleSx}
                    variant="h2"
                >
                    {/* A blank line rather than nothing while the title is on its way. An empty
                        heading has no line box at all, so the header stood a line short and every
                        page whose title is fetched - which is most of the detail pages - dropped its
                        whole body down the moment the name arrived. */}
                    {pageTitle || '\u00A0'}
                </Typography>
                {titleSuffix}
            </Box>
            {children && (
                <Box sx={{display: 'flex', alignItems: 'center', gap: 1, ml: 'auto', flexWrap: 'wrap'}}>
                    {children}
                </Box>
            )}
            {!onlyTitle && (
                <Button
                    type="submit"
                    variant="contained"
                    sx={{...actionButtonSx, ...(children ? {} : {ml: 'auto'})}}
                    onClick={onClick}
                >
                    {buttonText && <FormattedMessage id={buttonText}/>}
                </Button>
            )}
        </Box>
    );
};
